var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6154 1.125H2.47078C1.75254 1.125 1.125 1.6418 1.125 2.3516V15.5254C1.125 16.239 1.75254 16.875 2.47078 16.875H15.6115C16.3336 16.875 16.875 16.2348 16.875 15.5254V2.3516C16.8792 1.6418 16.3336 1.125 15.6154 1.125ZM6.00715 14.2534H3.75082V7.23797H6.00715V14.2534ZM4.95703 6.17133H4.94086C4.21875 6.17133 3.75117 5.63379 3.75117 4.9609C3.75117 4.2757 4.23105 3.75082 4.96934 3.75082C5.70762 3.75082 6.15938 4.27184 6.17555 4.9609C6.1752 5.63379 5.70762 6.17133 4.95703 6.17133ZM14.2534 14.2534H11.9971V10.4175C11.9971 9.49852 11.6687 8.87063 10.8524 8.87063C10.2287 8.87063 9.85957 9.2925 9.69539 9.70348C9.63387 9.85113 9.61734 10.0522 9.61734 10.2575V14.2534H7.36102V7.23797H9.61734V8.21426C9.9457 7.74668 10.4586 7.07379 11.6522 7.07379C13.1333 7.07379 14.2537 8.05008 14.2537 10.1549L14.2534 14.2534Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.eeec7970.svg";
export { ForwardRef as ReactComponent };